import React, { useState, useEffect, memo } from "react";

import { useDispatch, useReucer, useSelector } from "react-redux";

import {
  incrementTimer,
  startTimer,
  stopTimer,
} from "Store/features/public/publicPuzzleSlice";

import "./Stopwatch.css";

const Stopwatch = (props) => {
  const { small } = props;
  const dispatch = useDispatch();
  const activeModal = useSelector((state) => state.publicStateSlice.activeModal);

  const { time, timer_active } = useSelector(
    (state) => state.publicPuzzleSlice.puzzle.timer
  );
  const winner = useSelector((state) => state.publicPuzzleSlice.puzzle.winner);

  useEffect(() => {
    let timer;
    if (!timer_active && !winner && !activeModal) dispatch(startTimer());
    if (activeModal) {
      dispatch(stopTimer());
    } else if (!winner) {
      dispatch(startTimer());
    }
    if (timer_active && !activeModal && !winner) {
      timer = setInterval(() => {
        dispatch(incrementTimer());
      }, 1000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [winner,timer_active, activeModal]);

  const minutes = Math.floor(time / 60);
  const seconds = time % 60 < 10 ? `0${time % 60}` : time % 60;

  return (
    <div className={`stop-watch-container ${small ? "small" : ""}`}>
      {!small ? <div className="stop-watch-heading">Time Elapsed</div> : null}
      <div className={`stop-watch ${small ? "small" : ""}`}>
        {minutes}:{seconds}
      </div>
    </div>
  );
};

export default memo(Stopwatch);
